import { z } from 'zod';

import { MESSAGE_DATA_TYPES } from './discriminators';

export const payloadSchema = z.object({
  type: z.literal(MESSAGE_DATA_TYPES.MOD_INQUIRY),
  productIds: z.array(z.string()).min(1),
  questionType: z.string().optional(),
});

export type MODInquiryMessageData = z.infer<typeof payloadSchema>;

/**
 * The read path deliberately drops the producer's `.min(1)` constraint:
 * a stored message with an empty `productIds` should still render rather
 * than fail validation and blank its whole attribute bag.
 */
export const attributesSchema = z.object({
  productIds: z.array(z.string()).optional(),
});

export function createMODInquiryMessageData(
  productIds: string[],
  questionType?: string
): MODInquiryMessageData {
  return {
    type: MESSAGE_DATA_TYPES.MOD_INQUIRY,
    productIds,
    ...(questionType ? { questionType } : {}),
  };
}
